<template>
  <article>
    <vs-row align="center" justify="center" v-if="logo">
      <vs-col>
        <img class="logo" :src="logo_url"/>
      </vs-col>
      <h2>{{contentCopies.prize_header}}</h2>
      <h3 class="breaker-heading" v-html="contentCopies.prize_body"></h3>
    </vs-row>
    <div class="center">
      <div v-if="availablePrizes.length > 0" class="grid-prizes">
        <div
          :key="'prizes-row'+indexRow"
          v-for="(rowPrizes, indexRow) in availablePrizes"
          lg="3"
          sm="6"
          xs="12"
          vs-type="center"
          vs-justify="center"
          vs-align="center"
          :class="'row-card-prize row-n'+rowPrizes.length"
        >
          <a-card :key="prize.id" v-for="prize in rowPrizes" class="mt-2 card-prize" :ref="`prize_${prize.id}`">
            <div class="thumb-image-prize" :style="'background-image: url('+(prize.picture_url ? prize.picture_url : prize.picture)+')'">
              <a target="_blank" :href="prize.picture_url ? prize.picture_url : prize.picture"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#89898b"><rect fill="none" height="24" width="24"/><polygon points="21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71 17.71,7.71"/></svg></a>
            </div>
            <template slot="actions" class="ant-card-actions">
              <div :id="'btn-components-prizes-selectprize'+prize.id" @click="select(prize.id, prize)">
                <a-icon key="select" type="check" />Select
              </div>
            </template>
            <a-card-meta :title="prize.prizeName" :description="prize.sku">
              <a-avatar
                slot="avatar"
                src="https://res.cloudinary.com/gerardold/image/upload/c_scale,w_128/v1597374081/cup_uf3aps.png"
              />
            </a-card-meta>
          </a-card>
          <div class="clr"></div>
        </div>
        <div class="clr"></div>
      </div>
      <p v-else-if="!isLoaded">Loading...</p>
      <p v-else>- No prizes available -</p>

      <div class="input-field-size" v-if="allowSize">
        <label>{{contentCopies.prize_label_size}}</label>
        <vs-input
          id="btn-components-prizes-selectprize-description"
          v-model="sizePrize"
          placeholder="8.5" 
          color="#83bc00"
        />
      </div>
      <div class="text-error" v-if="sizePrize.length > 80">Your size description is too long.</div>
      <vs-row align="center" justify="center" class="mt-2">
       <vs-button id="btn-components-prizes-back" square color="#89898b" size="large" @click="returnCheckout">BACK</vs-button>
        <vs-button id="btn-components-prizes-claimmyprize" square color="#83bc00" size="large" @click="pickPrize">{{contentCopies.claim_text}}</vs-button>
      </vs-row>
      
    </div>
  </article>
</template>

<script>
export default {
  name: 'Home',
  props: {
    promoName: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      required: true,
    },
    logo:{
      type: String,
      require: false
    },
    logo_url:{
      type: String,
      require: false
    },
    contentCopies: {
      type: Object,
      require: true,
    },
    allowSize:{
      type: Boolean,
      require: false,
    },
  },
  methods: {
    select(id, prize) {
      document
        .querySelectorAll('.selected')
        .forEach(el => el.classList.remove('selected'));
      this.$refs[`prize_${id}`][0].$el.classList.add('selected');
      this.selectedPrize = prize;
    },
    pickPrize() {
      if (!this.selectedPrize) {
        this.$swal.fire({
          title: '',
          text: 'Please pick your prize',
          icon: 'error',
          showConfirmButton: true,
          timer: 3000,
        });
        return;
      }
      this.$emit('success', this.selectedPrize, this.sizePrize.trim());
    },
    returnCheckout(){
      this.$emit('goCheckout');
    },
    loadPrizes() {
      this.$http
        .get(`redeem/winners/availablePrizes?redeemToken=${this.token}`)
        .then(result => {
          if(result.data instanceof Array) {
            let tempList = [];
            for(let i = 0; i < result.data.length ; i++) {
              if(i%4 === 0 && i !== 0) {
                this.availablePrizes.push(tempList);
                tempList = [];
              }
              tempList.push(result.data[i])
            }
            if(tempList.length > 0) {
              this.availablePrizes.push(tempList);
            }
          }
          this.isLoaded = true;
        });
    },
  },
  data() {
    return {
      availablePrizes: [],
      selectedPrize: null,
      sizePrize: "",
      isLoaded: false,
    };
  },
  created() {
    this.loadPrizes();
  },
};
</script>

<style lang="scss" scoped>
article {
  width: 90%;
}

.mobile{
  display:none;
}
@media only screen and (min-width: 769px) {
  ::v-deep .breaker-heading {
    br {
      display: none;
    }
  }
}
@media only screen and (max-width: 768px) {
  .mobile{
    display:initial;
  }
  .desktop{
    display:none;
  }
}
h2 {
  color: #83bc00;
  width:100%;
}
.logo{
  max-width: 200px;
}

h1,
h2 {
  font-size: 48px;
  font-weight: 700;
  margin: 0.5rem 0;
  text-transform: uppercase;
}
h3 {
  font-weight: 700;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

p {
  font-size: 1.2rem;
  font-weight: 400;
}

.mt-2 {
  margin-top: 1rem;
}

::v-deep .ant-card {
  width: 300px;
  margin: auto;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  @media only screen and (max-width: 1024px) {
    margin: 1rem auto;
    width: 80%;
  }

  .ant-card-actions {
    background: #89898b;

    li {
      color: white;
      margin: 0;
      span {
        font-size: 18px;
        font-weight: bold;
        i {
          margin-right: 5px;
        }
        & > div {
          padding: 12px 0;
        }
      }
      span:hover {
        color: blue;
      }
    }
  }
}

::v-deep .ant-card-meta-detail {
  text-align: left;
}

::v-deep .vs-button__content {
  font-weight: 600;
}

.center-card{
  width:auto;
  justify-content: center!important;
}
@media (max-width: 768px) {
    h1{
      font-size: 34px;
    }
    h2{
      font-size: 28px;
    }
    h3{
      font-size: 18px;
    }
}

.selected {
  filter: drop-shadow(0 0 0.3rem yellowgreen);
  transition: all 0.5s ease-in;

  ::v-deep > .ant-card-actions {
    background: yellowgreen;

    li {
      color: white;

      span:hover {
        color: white;
      }
    }
  }
}

.thumb-image-prize {
  position: relative;
  cursor: default;
  background-repeat: no-repeat;
  background-color: #fff;
  background-position: center;
  background-size: contain;
  margin-bottom: 20px;
  height: 200px;
  width: 100%;
  a {
    position: relative;
    overflow: hidden;
    position: absolute;
    cursor: pointer;
    right: 0px;
    top: 0px;
    display: block;
    height: 30px;
    width: 30px;
    background-color: #fff;
    border: 1px solid #89898b;
    border-radius: 3px;
    svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
}
.input-field-size {
  margin-top: 40px;
  text-align: center;
  & > label {
    padding-bottom: 10px;
    display: block;
  }
  & > div {
    display: table;
    margin: 0 auto;
  }
  ::v-deep input {
    border: 1px solid #ccc;
  }
}
.text-error {
  color: rgb(255 24 99);
  margin-top: 10px;
}
</style>
